if (!customElements.get('omni-health-page')) {
 customElements.define('omni-health-page', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   let active = 0;
   const features = [...this.querySelectorAll('[data-feature]')];
   const select = index => {
    active = Math.max(0, Math.min(features.length - 1, index));
    features.forEach((button, i) => {
     button.setAttribute('aria-expanded', String(i === active));
     button.closest('.oh2-feature').classList.toggle('is-active', i === active);
     this.querySelector('#' + button.getAttribute('aria-controls')).hidden = i !== active;
     const panel = this.querySelector(`[data-panel="${i}"]`);
     panel.hidden = i !== active;
     if (i !== active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    this.querySelector('[data-prev]').disabled = active === 0;
    this.querySelector('[data-next]').disabled = active === features.length - 1;
    this.querySelector('[data-count]').textContent = `0${active + 1} / 0${features.length}`;
   };
   features.forEach((button,i) => button.addEventListener('click', () => select(i)));
   this.querySelector('[data-prev]')?.addEventListener('click', () => select(active - 1));
   this.querySelector('[data-next]')?.addEventListener('click', () => select(active + 1));
   this.querySelectorAll('[data-story]').forEach(button => button.addEventListener('click', () => {
    this.querySelectorAll('[data-story]').forEach(other => {
     const selected = other === button;
     other.setAttribute('aria-expanded', String(selected));
     other.closest('.oh2-story').classList.toggle('is-active', selected);
    });
   }));
  }
 });
}
